<template>
  <div>
    <h1 class="text-3xl sm:text-4xl font-bold text-gray-900">
      Inicia tu sesión
    </h1>

    <div class="mt-8 space-y-5">
      <p class="font-medium text-neutral-700">
        Selecciona un método para iniciar sesión
      </p>

      <button class="mob-btn w-full" @click="loginWithGoogle()">
        <img src="/icons/google.svg" alt="" />
        Ingresa con Google
      </button>

      <p class="font-medium text-neutral-700">
        o inicia tu sesión con correo electrónico
      </p>

      <form class="space-y-4" @submit.prevent="localLogin">
        <MobTextField
          label="Email"
          v-model="loginForm.email"
          placeholder="ejemplo@correo.com"
          :errorText="formErrorMessage.email"
        />
        <MobTextField
          label="Contraseña"
          v-model="loginForm.password"
          type="password"
          :errorText="
            formErrorMessage.password
              ? formErrorMessage.password
              : formErrorMessage.passwordValidation
              ? formErrorMessage.passwordValidation
              : null
          "
        />
        <router-link
          to="/recover-password"
          class="text-right text-blue-600 block"
        >
          Olvidé mi contraseña
        </router-link>
        <button
          type="submit"
          class="mob-btn mob-cta-gold w-full"
        >
          Iniciar sesión
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import {
  localLogin,
  googleLogin,
  getUserData,
} from "@/services/auth.service.js";
import { MobTextField } from "@/views/V2/components";
import { handleGoogleLogin } from "@/Utils/oauth-helper";
import { Capacitor } from "@capacitor/core";

export default {
  name: "LoginForm",
  components: {
    MobTextField,
  },
  data() {
    return {
      userTypes: [
        { key: "ROLE_STUDENT", label: "Estudiante" },
        // { key: "ROLE_TEACHER", label: "Profesor" },
        { key: "ROLE_ACADEMIC_ADMIN", label: "Administrador académico" },
      ],
      loginForm: {
        email: "",
        password: "",
      },
      formErrorMessage: {
        email: null,
        password: null,
        server: null,
      },
    };
  },
  methods: {
    async getUserData(token) {
      let loader = this.$loading.show({});

      try {
        loader.hide();
        const response = await getUserData(token);

        const roleNames = (response.data?.roles || []).map((role) => role.name);
        const isAcademicAdmin = roleNames.includes("ROLE_ACADEMIC_ADMIN");
        const hasStudentRole = roleNames.includes("ROLE_STUDENT");
        const hasAdminRole = roleNames.includes("ROLE_ADMIN");
        if (
          response.data &&
          (response.data.emailVerified ||
            ["google", "facebook"].includes(response.data.provider) ||
            isAcademicAdmin)
        ) {
          this.$store.dispatch("auth/setLogin", {
            ...response.data,
            ...{ token: token },
          });

          if (isAcademicAdmin && (hasStudentRole || hasAdminRole)) {
            this.$router.push("/v2/auth/role-select");
          } else {
            this.goToDashboard();
          }
        } else {
          this.$store.dispatch("auth/logout");
          this.$toasted.info("Por favor verifica tu email para continuar.", {
            position: "top-center",
            duration: 3000,
          });
        }
      } catch (error) {
        console.error("[Login] Error obteniendo datos del usuario:", error);
        console.error("[Login] Response:", error.response);
        console.error("[Login] Status:", error.response?.status);
        loader.hide();
      }
    },
    async localLogin() {
      if (this.validateLoginInfo()) {
        this.loginForm.username = this.loginForm.email;

        try {
          const response = await localLogin(this.loginForm);

          if (response.data && response.data.accessToken) {
            this.getUserData(response.data.accessToken);
          } else {
            console.error("[Login] No se recibió accessToken en la respuesta");
            this.$toasted.error("Error: No se recibió token de autenticación.", {
              position: "top-center",
              duration: 3000,
            });
          }
        } catch (error) {
          console.error("[Login] Error completo:", error);
          console.error("[Login] Response:", error.response);
          console.error("[Login] Status:", error.response?.status);
          console.error("[Login] Data:", error.response?.data);
          
          const errorMessage = error.response?.data?.message || 
                              error.response?.data?.error || 
                              error.message || 
                              "Correo o contraseña inválido.";
          
          this.$toasted.error(errorMessage, {
            position: "top-center",
            duration: 3000,
          });
        }
      }
    },
    async loginWithGoogle() {
      // Detectar si está en mobile (Capacitor) o web
      if (Capacitor.isNativePlatform()) {
        // En mobile, usar handleGoogleLogin que usa el plugin Browser de Capacitor
        const authUrl = import.meta.env.VITE_GOOGLE_AUTH_URL;
        await handleGoogleLogin(authUrl);
      } else {
        // En web, usar el método original con window.open
        googleLogin((token) => {
          // Cuando recibimos el token del callback, obtener los datos del usuario
          if (token) {
            this.getUserData(token);
          } else {
            // Si no hay token, solo redirigir (para compatibilidad con código anterior)
            this.goToDashboard();
          }
        });
      }
    },
    validateLoginInfo() {
      let errorCount = 0;

      if (!this.loginForm.email) {
        this.formErrorMessage.email = "Este campo es requerido";
        errorCount++;
      } else {
        this.formErrorMessage.email = null;
      }
      if (!this.loginForm.password) {
        this.formErrorMessage.password = "Este campo es requerido";
        errorCount++;
      } else {
        this.formErrorMessage.password = null;
      }

      return errorCount === 0;
    },
    goToDashboard() {
      const redirect = this.$route.query.redirect;
      if (redirect) {
        this.$router.push(redirect);
        return;
      }

      const role = localStorage.getItem("role");
      // if (role === "ROLE_TEACHER") {
      if (role === "ROLE_ACADEMIC_ADMIN") {
        this.$router.push("/teacher/groups");
        return;
      }
      
      this.$router.push("/dashboard");
    },
  },
  mounted() {
    if (this.$route.query.error) {
      this.$toasted.error(localStorage.getItem("loginError"), {
        position: "top-center",
        duration: 5000,
      });
      localStorage.removeItem("loginError");
    }
    const authInfo = JSON.parse(window.localStorage.getItem("auth"));
    if (authInfo && authInfo.isAuthenticated) {
      this.goToDashboard();
    }
  },
};
</script>
